import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Wifi"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", { d: "M12 20.25C12.8284 20.25 13.5 19.5784 13.5 18.75 13.5 17.9216 12.8284 17.25 12 17.25 11.1716 17.25 10.5 17.9216 10.5 18.75 10.5 19.5784 11.1716 20.25 12 20.25zM7.85254 14.4251 8.91274 15.4849C9.74385 14.6934 10.8472 14.2513 11.9949 14.25 13.1426 14.2487 14.247 14.6883 15.0799 15.4779L16.14 14.4177C15.0261 13.3464 13.5403 12.7486 11.9948 12.75 10.4493 12.7514 8.96452 13.3519 7.85254 14.4252V14.4251zM4.6721 11.2444 5.7323 12.3046C7.40626 10.6681 9.65384 9.75122 11.9948 9.74982 14.3358 9.74842 16.5845 10.6626 18.2604 12.2971L19.3204 11.2371C17.3635 9.32104 14.7333 8.2486 11.9946 8.25 9.25584 8.2514 6.62681 9.32653 4.67188 11.2446L4.6721 11.2444z" }, null, -1);
const _hoisted_3 = /* @__PURE__ */ _createElementVNode("path", { d: "M22.5 8.05596C19.7017 5.29682 15.9298 3.75 12 3.75C8.07019 3.75 4.29831 5.29682 1.5 8.05596V8.07284L2.55323 9.12606C5.06893 6.64389 8.46049 5.25158 11.9946 5.25017C15.5287 5.24877 18.9214 6.63839 21.439 9.11856L22.5 8.05746V8.05596Z" }, null, -1);
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Wifi.vue"]]);
